var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isNBYXSupplier && !_vm.isLoading
    ? _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
          staticStyle: {
            "margin-bottom": "12px",
            "min-width": "var(--table-width)",
          },
          attrs: { "element-loading-text": "加载中" },
        },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.tabsClick },
              model: {
                value: _vm.originType,
                callback: function ($$v) {
                  _vm.originType = $$v
                },
                expression: "originType",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: "网上农博", name: "1", disabled: _vm.disabled },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: "中国土特产",
                  name: "3",
                  disabled: _vm.disabled,
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }